<template>
  <div class="reference" v-if="isVisible">
    <div class="tile is-ancestor">
      <div class="tile is-parent is-6">
        <div class="tile is-child">
          <nav class="panel">
            <p class="panel-heading">
              注参照
            </p>
            <router-link v-for="(term, index) in ndc.seeAlso" :key="index"
              class="panel-block has-text-link" :to="{ path: term.id }">
              {{ term.label }} ({{notation(term.id)}})
            </router-link>
          </nav>
        </div>
      </div>
      <div class="tile is-parent is-6">
        <div class="tile is-child">
          <nav class="panel">
            <p class="panel-heading">
              をも見よ参照
            </p>
            <router-link v-for="(term, index) in ndc.related" :key="index"
              class="panel-block has-text-link" :to="{ path: term.id }">
              {{ term.label }} ({{notation(term.id)}})
            </router-link>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { notation } from '../utils';

export default {
  name: 'Reference',
  props: [
    'ndc',
  ],
  data() {
    return {
    };
  },
  methods: {
    notation,
  },
  computed: {
    isVisible() {
      return (this.ndc.seeAlso && this.ndc.seeAlso.length > 0)
        || (this.ndc.related && this.ndc.related.length > 0);
    },
  },
};
</script>

<style scoped>
.reference {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Reference.vue